import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

export const createReminder = async (payload) => {
  return axiosInstance.post(API_ENDPOINTS.CREATE_REMINDER, payload);
};

export default {
  createReminder,
};

